{
	"activeAll": "Tout activer",
	"activeAllQuestion": "Tout activer ?",
	"addProductButton": "Ajouter Produit",
	"importProductsButton": "Importer produits en masse",
	"checkAllItems": "Sélectionner tous les produits ({{counter}})",
	"deleteProducts": "Supprimer Produits",
	"deleteSelect": "Supprimer la sélection",
	"deleteSelectedProducts": "Supprimer la sélection",
	"disableAll": "Tout désactiver",
	"disableAllQuestion": "Tout désactiver ?",
	"downloadQrCodeAppSell": "Télécharger les QR codes de vente pour l'app ZIG",
	"editProducts": "Modifier Produits",
	"editProductsViaExcel": "Modifier les produits via Excel",
	"exportToExcelButton": "Exporter tableau",
	"findFiscalGroupError": "Groupe fiscal enregistré introuvable",
	"findFiscalProfileError": "Profil fiscal enregistré introuvable",
	"getDescriptionDialogActive": "Voulez-vous activer ce produit dans les produits combinables qu'il compose ?",
	"getDescriptionDialogDisable": "Voulez-vous désactiver ce produit dans les produits combinables qu'il compose ?",
	"getTitleDialogActive": "Activer Produit",
	"getTitleDialogDisable": "Désactiver Produit",
	"importModal": {
		"alertMessage": "Attention ! la valeur des produits est renseignée en cents, ex : 123 équivaut à 1.23€",
		"buttonText": "Choisir tableau",
		"downloadSheet": "Télécharger le tableau",
		"import": "Importer",
		"sheetFileName": "Produits",
		"title": "Importer des tableaux",
		"table": {
			"columns": {
				"product": "Produit",
				"error": "Erreur",
				"description": "Description"
			},
			"errors": {
				"invalidTaxData": "Données fiscales,",
				"ncm": "NCM",
				"cest": "CEST",
				"duplicatedFiscalCode": "SKU en double",
				"productNotFound": "Produit non trouvé",
				"categoryWithSubcategory": "Catégorie",
				"supercategoryNotFound": "Type de produit",
				"name": "Nom",
				"category": "Catégorie",
				"hasAlcohol": "Contient de l'alcool",
				"isHiddenFromApp": "Cacher le produit",
				"value": "Prix",
				"kind": "Type de produit",
				"beerAbv": "ABV - Teneur en alcool",
				"other": "Inconnue"
			},
			"errorsDescription": {
				"name": "Nom du produit non renseigné",
				"category": "Catégorie de produit non spécifiée",
				"hasAlcohol": "Le champ doit être vrai ou faux",
				"isHiddenFromApp": "Le champ doit être vrai ou faux",
				"value": "Le prix du produit n'est pas valide",
				"kind": "Le type de produit est invalide",
				"beerAbv": "ABV - La teneur en alcool doit être un nombre",
				"other": "Erreur inconnue"
			}
		}
	},
	"limitOver": "Limite au-dessus de {{limit}} sélectionné",
	"onDeleteMessage": {
		"cancelText": "Non",
		"content": "Attention ! Les produits seront définitivement supprimés.",
		"okText": "Oui",
		"title_one": "Voulez-vous supprimer {{counter}} produit?",
		"title_other": "Voulez-vous supprimer {{counter}} produits?"
	},
	"onDeleteSelectProductsError": "Oups ! Un problème est survenu, veuillez réessayer",
	"productWithoutCategory": "Produits sans catégorie de menu",
	"productsByCategory": "Produits par catégorie",
	"searchLabel": "Rechercher",
	"searchPlaceholder": "Recherche produits...",
	"sortByCategory": "Trier par catégorie",
	"sortByMenuCategory": "Trier par catégorie de menu",
	"syncModal": {
		"title": "Synchroniser les produits",
		"syncButton": "Synchroniser",
		"activeSyncOptionCheckbox": "Activer les produits synchronisés pour la vente à la livraison",
		"alertMessage": "Les produits qui ne sont pas en cours de livraison seront créés avec les mêmes informations.",
		"chooseTheVariablesCheckbox": {
			"all": "Tous",
			"category": "Catégorie",
			"description": "Description",
			"mountableItems": "Articles combinables",
			"name": "Nom",
			"order": "Commande",
			"picture": "Image",
			"price": "Prix",
			"subcategory": "Sous catégorie",
			"title": "Choisissez les variables qui seront synchronisées pour les produits déjà enregistrés dans la livraison :"
		},
		"chooseYourMenusMultiSelect": "Choisissez vos menus",
		"successFeedback": "Succès, tous les produits sont synchronisés !",
		"warningFeedback": "Certains produits ont présenté des problèmes de synchronisation.",
		"warningFeedbackTable": {
			"description": "Description",
			"type": "Type"
		}
	},
	"syncWithDelivery": "Synchronisation avec la livraison",
	"tabTitle": "Produits",
	"table": {
		"active": "Activer",
		"activeBars": "Actives Bars",
		"actions": "Actions",
		"delete": "Supprimer",
		"duplicate": "Dupliquer",
		"edit": "Modifier",
		"fiscalData": "Données fiscales",
		"hasProductionRule": "Tableau",
		"mountableDescription": "Produit Montable",
		"name": "Produit",
		"noOption": "Non",
		"onDeleteProductMessage": "Voulez-vous supprimer le produit {{productName}}?",
		"value": "Prix",
		"yesOption": "Oui",
		"fiscalCode": "SKU"
	},
	"testEmission": {
		"loadingText": "Veuillez patienter, nous testons les produits sélectionnés",
		"success": "Les données fiscales ont été testées avec succès",
		"successDescription": "Aucune erreur n'a été trouvée dans les données présentées",
		"testing": "Tests {{currentTest}}/{{length}}",
		"titleError": "Oups, nous avons trouvé des erreurs",
		"titleSuccess": "Test des données fiscales - Succès",
		"titleTesting": "Test des données fiscales",
		"updating": "Mise à jour des produits..."
	},
	"testFiscalData": "Test des données fiscales",
	"uncheckAllItems": "Désélectionner tous les produits ({{counter}})",
	"xlsxPicker": {
		"cell": {
			"falseHasAlcohol": "FAUX",
			"trueHasAlcohol": "VRAI"
		},
		"columns": {
			"bars": "Bars",
			"systemProductId": "ID Produit du Système",
			"category": "Catégorie",
			"cest": "Fiscal - CEST",
			"description": "Description",
			"fiscalCode": "SKU",
			"fiscalProductGroup": "Fiscal - Groupe fiscal",
			"fiscalProfile": "Fiscal - Profil fiscal",
			"fiscalIcmsBaseCalculoRetSt": "Base de calcul de l'ICMS retenu lors de l'opération précédente",
			"fiscalIcmsValorSubistituto": "Valeur de l'ICMS propre du substitut",
			"fiscalIcmsAliquotaFinal": "Taux supporté par le consommateur final",
			"hasAlcohol": "Contient de l'alcool ?",
			"id": "ID Produit",
			"image": "Image",
			"kind": "Type de produit",
			"menuCategory": "Catégorie de menu",
			"name": "Nom",
			"ncm": "Fiscal - NCM",
			"price": "Prix",
			"products": "produits",
			"variablePrice": "Prix variable",
			"beerBrand": "Marque de bière",
			"beerStyle": "Style de bière",
			"beerAbv": "ABV - Teneur en alcool",
			"isStockable": "Stockable",
			"fileName": "produits_{{placeName}}"
		},
		"sheetDownload": "Télécharger un modèle de tableau",
		"sheetFeedback": {
			"errorMessage": "Tableau invalide, téléchargez-le à nouveau et apportez les modifications nécessaires.",
			"successMessage": "Tableau valide!"
		},
		"sheetHumanizeErrorMessage": {
			"default": "Une erreur s'est produite lors de l'importation du tableau",
			"emptyHeaderCell": "Nom manquant dans les colonnes",
			"emptySheet": "Ce tableau est vide",
			"sheetPoorlyFormatted": "Formatage du tableau pour la police Calibri, taille 11, suppression des espaces, des retours à la ligne inutiles et des caractères gras.",
			"unidentifieldColumn": "Erreur dans les noms de colonnes",
			"verifyBaseSheet": ", veuillez consulter le modèle de tableau ou l'utiliser comme tableau de base."
		},
		"sheetNameExample": "(exemple)",
		"sheetNameInvalid": "(invalide)",
		"sheetXlsxPicker": "Choisir un tableau",
		"duplicateError": "Des valeurs en double ont été identifiées dans le tableau envoyé.\n\nVeuillez réviser le fichier, corriger les éléments en double et envoyer à nouveau pour continuer.",
		"invalidSheetFormat": "Le tableau envoyé a un format invalide pour ce lieu.\n\nVeuillez utiliser le format correct basé sur le pays du lieu et envoyer à nouveau."
	},
	"manageProducts": "Gestion des produits",
	"managePlaceProducts": "Gérer les produits du lieu",
	"filters": {
		"status": {
			"all": "Tous",
			"active": "Actif",
			"inactive": "Inactif"
		}
	}
}
